import { Component, inject, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgClass } from '@angular/common';
import { LocalStorageService, STORAGE_KEYS } from '../../services/local-storage.service';

@Component({
    selector: 'app-lending-preferences-banner',
    standalone: true,
    imports: [RouterModule, NgClass],
    templateUrl: './lending-preferences-banner.component.html',
    styleUrl: './lending-preferences-banner.component.scss'
})
export class LendingPreferencesBannerComponent {
  private storageService = inject(LocalStorageService);

  isFirstTime = input<boolean>(false);
  shouldStack = input<boolean>(false);
  onRemindMeLater = output<void>();

  remindMeLater() {
    this.storageService.setRaw(STORAGE_KEYS.LENDING_PREFERENCE_REMIND_ME_LATER, new Date().toISOString());
    this.onRemindMeLater.emit();
  }
}
